import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { resolveInputProps } from "./inputProps.js";
/** Kanonisches mehrzeiliges Textfeld für moderne Oberflächen. */
export const Textarea = forwardRef(function Textarea(props, ref) {
    const { size, invalid, disabled, className, ...rest } = props;
    const resolved = resolveInputProps({ size, invalid, disabled, className });
    return (_jsx("textarea", { ref: ref, className: `cp-textarea ${resolved.className}`, "data-size": resolved["data-size"], "aria-invalid": resolved["aria-invalid"], disabled: resolved.disabled, ...rest }));
});
